import { Component, OnInit, Input, OnChanges, Output, EventEmitter, inject} from "@angular/core";
import { SelectItem } from "primeng/api";
import { MemberReferral } from "../../../../services/models/member-referral";
import { MemberInfoService } from "../../../../services/member-info.service";
import { catchError, finalize, switchMap, tap } from "rxjs/operators";

@Component({
  selector: "app-member-referrals",
  templateUrl: "./member-referrals.component.html",
  styleUrls: ["./member-referrals.component.scss"],
})
export class MemberReferralsComponent implements OnInit, OnChanges {
  @Input() tabName: boolean;
  @Input() isLoading: boolean;
  @Output() referralsChange = new EventEmitter<boolean>();

  private memberInfoService = inject(MemberInfoService);
  public sortOptions: SelectItem[] = [
    { label: "Most recent referrals", value: "dateReceived" },
    { label: "Status", value: "referralStatus" },
    { label: "Referral code", value: "referralId" },
    { label: "Referred provider", value: "referredProvider.providerName" },
  ];
  public sortField: string;
  public sortOrder: number;
  public sortKey: SelectItem;
  public member$ = this.memberInfoService.selectedMemberChanged$
    .pipe(
      switchMap(data => {
        return this.memberInfoService.getMemberReferral(data.cin, data.grgrCk, data.pcpInfo.pcpId);
      }),
      tap(() => {
        this.sortField = null;
        this.referralsChange.emit(true);
      }),
      catchError((error)  => {
        console.debug("catchError", error);
        return new Array<MemberReferral>();
      }),
      finalize(() =>{
        this.referralsChange.emit(true);
      })
    );

  ngOnChanges() {
    //reset the sortField when using the member quick search
    this.sortField = null;
  }

  ngOnInit() {
    this.sortField = null;
    this.sortKey = this.sortOptions[0];
  }

  public onSortChange(event) {
    const value = event.value.value;
    if (value === "dateReceived") {
      this.sortOrder = -1;
    }
    else {
      this.sortOrder = 1;
    }
    this.sortField = value;
  }

  public onSortInit(event) {
    this.sortField = this.sortKey.value;
    this.sortOrder = event.sortOrder;
  }
}
